import React, { useCallback, useContext } from 'react';
import { Card } from 'react-bootstrap';

import { faPlus, faMinus, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import type { CategorySupplierProps } from '../types';
import type { SelectedSupplier } from '@components/Supplier/AddSupplier';

import scss from './ReviewList.module.scss';

import SupplierSearch from '@components/SupplierSearch';
import CategorySupplierExpanded from './CategorySupplierExpanded';

import { BulkReviewsContext, type BulkReviewsContextType } from '../context';
import { deepCopy } from '@helper/objectHelper';
import { parseNumeric } from '@helper/numberHelper';
import cl from 'classnames';

const CategoryCompressed = ({ category, review }: CategorySupplierProps) => {
    const { showValidationMessages, addUpdateReview, addEmptyReview } = useContext<BulkReviewsContextType>(BulkReviewsContext);
    
    const handleSaveSupplier = useCallback((supplier: SelectedSupplier | null) => {
        if (!!addEmptyReview && supplier !== null) {
            const supplierId = parseNumeric(supplier.Id);
            !!supplierId && addEmptyReview(supplierId, supplier.Name, category, false);
        }
    }, [category, addEmptyReview]);

    const toggleExpanded = useCallback(() => {
        if (!!review && !!addUpdateReview) {
            const updatedReview = deepCopy(review);
            updatedReview.expanded = !updatedReview.expanded;
            addUpdateReview(updatedReview);
        }
    }, [review, addUpdateReview]);

    const reviewIncomplete = (!!review && !review.complete);

    return (
        <Card className={reviewIncomplete ? `${scss.reviewMainContainerIncomplete} ${showValidationMessages && scss.reviewBorderRed}` : undefined}>
            {reviewIncomplete && <div className={`${scss.requiredFields} text-danger required-fields`}>* Required fields</div>}
            <Card.Body>
                <div data-testid="categoryCard" className={!!review?.supplierName ? scss.compressedContainerSupplier : scss.compressedContainer}>
                    <div className={scss.compressedItemLeft} data-testid="categoryName">
                        {!!category.icon && <img src={category.icon} className={scss.categoryIcon} data-testid="categoryIcon" />}
                        {!!review ?
                            <div>
                                <div><strong data-testid={'supplierName'}>{review?.supplierName}</strong></div>
                                {!review?.complete && <div className={`${scss.incompleteReview} text-danger`}>Incomplete</div>}
                                {!!review?.complete && <div className={scss.completeReview}>
                                    {Array.from({ length: review.userStarRating }).map((_, index) => (
                                        <Icon key={index} icon={faStar} />
                                    ))}
                                </div>}
                            </div> :
                            <strong>{category.name}</strong>}
                    </div>
                    <div className={scss.compressedItemRight}>
                        {!!review?.supplierName ?
                            <div className={cl(scss.compressedSupplierName, { 'text-danger': (showValidationMessages && !review.complete) })}>
                                {!!review.expanded ?
                                    <Icon icon={faMinus} className={scss.toggleIcon} onClick={toggleExpanded} />
                                    :
                                    <Icon icon={faPlus} className={scss.toggleIcon} onClick={toggleExpanded} />
                                }
                                
                            </div>
                            :
                            <SupplierSearch
                                categoryName={category.name}
                                categorySlug={category.slug}
                                placeholder={"Type in supplier's name"}
                                hideBackground={true}
                                isFocus={false}
                                handleSaveSupplier={handleSaveSupplier}
                            />}
                    </div>
                </div>
                {!!review && <CategorySupplierExpanded category={category} review={review} />}
            </Card.Body>
        </Card>
    )
}

export default CategoryCompressed
